/**************************************************
 * Nombre:       IngresoTexto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {InputAdornment, TextField} from "@mui/material";
import {AttachMoney} from "@mui/icons-material";
import {NumericFormat} from "react-number-format";
import {Controller} from 'react-hook-form'


const IngresoDinero = ({
                           props,
                           nombre,
                           dato,
                           Icono = AttachMoney,
                           size = 'small',
                           editable = true
                       }) => {
    const {register, errors, control} = props


    const TextMui = ({...props}) => {

        return (
            <TextField
                {...props}
                slotProps={{
                    input: {
                        startAdornment: (
                            <InputAdornment position="start">
                                <Icono color={'primary'}/>
                            </InputAdornment>
                        ),
                        disableUnderline: true,
                    },
                    inputLabel: {
                        sx: {marginLeft: -1}
                    }
                }
                }
                disabled={!editable}
                fullWidth
                size={size}
                label={nombre}
            />
        )
    }


    return (
        <Controller
            control={control}
            name={dato}
            defaultValue={0}

            render={({field: {onChange, onBlur, value, ref, name}}) => (
                <NumericFormat
                    defaultValue={0}
                    customInput={TextMui}
                    thousandSeparator={true}
                    prefix={"$ "}
                    value={value}
                    // onChange={onChange}
                    onValueChange={values => {
                        const {floatValue} = values;
                        onChange({
                            target: {
                                name: name,
                                value: floatValue
                            }
                        });
                    }}


                />
            )}
            size={size}
        />


    )

}
export default IngresoDinero